import * as React from "react";
import Assets from "src/presentation/assets/img/assets";
import GoldLink from "src/presentation/common/atom/btn/gold_link";
import styled from "styled-components";
import {ConstBorderRound, ConstShadow,} from "../../../../config/styles_const/styles_const";
import {Customer, Status} from "../../../../domain/model/customer";
import {JobCareer} from "../../../../domain/model/job_career";
import {PastCaseProject} from "../../../../domain/model/past_case_project";
import OuterLink from "../../../common/atom/outer_link";
import HeadlineSmall from "../../../common/atom/text/headline_small";
import Paragraph from "../../../common/atom/text/paragraph";
import PageWrapper from "../../../common/atom/wrapper/page_wrapper";
import CustomerDashboardCard from "../../../common/organism/card/customer_dashboard_card";
import Progress from "../../../common/organism/progress";
import Faq from "../../faq";

interface IProps {
    isInit: boolean;
    isLoading: boolean;
    customer: Customer | null;
    jobCareers: JobCareer[];
    pastCaseProjects: PastCaseProject[];
    handleStartStandard: () => void;
}

const CustomerTopPageComponent: React.FC<IProps> = (props) => {
    const {
        isLoading,
        customer,
        jobCareers,
        pastCaseProjects,
        handleStartStandard,
    } = props;

    if (isLoading) {
        return <Progress canAnimation={false}/>;
    }

    const isActive: boolean = customer
        ? customer.status === Status.Status_Active
        : false;

    return (
        <PageWrapper>
            <Faq title={"ダッシュボードの使い方"}
                 text={"ダッシュボードにはプロフィール情報の入力率が表示され、スカウトを受けるためには表示されているチェックボックスをすべて埋めて100%を目指すことが重要です。"}
                 link={
                     "https://branch-saturn-9ef.notion.site/178b91fe393e8029bd4cc5dcc7f5dc0c"
                 }/>

            <div style={{display: "flex", marginBottom: 12, marginTop: 20}}>
                <a
                    href="/customer/project-sharing"
                    style={{display: "block", flex: 1}}
                >
                    <img src={Assets.sharingBanner} style={{width: "100%"}}/>
                </a>
            </div>
            {/*<div style={{display: "flex", marginBottom: 40}}>
                <a
                    href={
                        localStorage.getItem("partnerStoreTermsAccepted") === "1"
                            ? "/customer/partner-store-list"
                            : "/customer/partner-store"
                    }
                    style={{display: "block", flex: 1}}
                >
                    <img src={Assets.partnerStoreBanner} style={{width: "100%"}}/>
                </a>
            </div>*/}

            <p style={{fontWeight: "bold", fontSize: 18, lineHeight: "30px"}}>
                メニュー
            </p>
            <div style={{display: "flex", marginBottom: 40}}>
                <MenuLink to="/customer/mypage/customer/_edit">
                    マイページを編集する
                </MenuLink>
                <MenuLink to="/customer/mypage/customer">マイページを確認する</MenuLink>
                <MenuLink to="/customer/messages">メッセージを確認する</MenuLink>
                <MenuLink to="/customer/projects?q=&p=1">案件を探す</MenuLink>
                <MenuLink to="">FAQをみる</MenuLink>
            </div>

            <CustomerDashboardCard
                customer={customer}
                jobCareers={jobCareers}
                pastCaseProjects={pastCaseProjects}
            />

            <FaqWrapper style={{marginBottom: 40}}>
                <FaqTitle>
                    <HeadlineSmall>よくある質問</HeadlineSmall>
                </FaqTitle>
                <FaqTextWrapper>
                    <OuterLink
                        href={
                            "https://liberaexpertnetwork.notion.site/EXPERT-NETWORK-8666ffcb52fd49d3b49c195e9e5daef6?pvs=97#2d3a1d2e32654d9eaae30cb25f8df045"
                        }
                        target="_blank"
                        rel="noopener"
                    >
                        <FaqText bold={true}>
                            案件エントリー後の具体的な流れについて教えてください
                        </FaqText>
                    </OuterLink>
                    <OuterLink
                        href={
                            "https://liberaexpertnetwork.notion.site/EXPERT-NETWORK-8666ffcb52fd49d3b49c195e9e5daef6?pvs=97#034374c7e3284b07892754342f02180e"
                        }
                        target="_blank"
                        rel="noopener"
                    >
                        <FaqText bold={true}>
                            特定の企業にプロフィールを見れないようにしたいです
                        </FaqText>
                    </OuterLink>
                    <OuterLink
                        href={
                            "https://liberaexpertnetwork.notion.site/EXPERT-NETWORK-8666ffcb52fd49d3b49c195e9e5daef6?pvs=97#2c9fb53e18894d3394bc87fd4967ed35"
                        }
                        target="_blank"
                        rel="noopener"
                    >
                        <FaqText bold={true}>
                            案件にエントリーしたのですが、企業から連絡が返ってきません
                        </FaqText>
                    </OuterLink>
                </FaqTextWrapper>
            </FaqWrapper>

            <div style={{display: "flex", marginBottom: 20}}>
                <a
                    href="https://www.zeiri4.com/shoukai/promotion/external-cooperation/800/?utm_source=libera&utm_medium=gaiburenkei&utm_campaign=expert_mypage"
                    target="_blank"
                    style={{display: "block", flex: 1, marginRight: 23}}
                >
                    <img src={Assets.zeirishi} style={{width: "100%"}}/>
                </a>
                <a
                    href="https://www.bengo4.com/ls/vlrxfv7m/"
                    target="_blank"
                    style={{display: "block", flex: 1}}
                >
                    <img src={Assets.bengoshi} style={{width: "100%"}}/>
                </a>
            </div>
        </PageWrapper>
    );
};

export default CustomerTopPageComponent;

const ContractWrapper = styled.div``;

const ContractTitle = styled.div`
    margin-top: 40px;
    margin-bottom: 15px;
`;

const ToolsWrapper = styled.div`
    margin-top: 40px;
`;

const ToolsTitle = styled.div`
    margin-bottom: 15px;
`;

const ToolCardsWrapper = styled.div`
    margin-bottom: 40px;
`;

const FaqWrapper = styled.div`
    margin-top: 40px;
`;

const FaqTitle = styled.div`
    margin-bottom: 15px;
`;

const FaqTextWrapper = styled.div`
    display: flex;
    flex-wrap: wrap;
`;

const FaqText = styled(Paragraph)`
    box-shadow: ${ConstShadow.DropShadow};
    border-radius: ${ConstBorderRound.CornerRoundAll};
    padding: 10px 30px;
    width: fit-content;
    margin: 0 15px 15px 0;
    transition: all 0.3s ease;

    &:hover {
        box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.4);
    }
`;

const MenuLink = styled(GoldLink)`
    // width: 100px;
    margin-right: 10px;
    margin-top: 10px;
    margin-right: 10px;
    font-size: 12px;
    text-align: center;
`;



// WEBPACK FOOTER //
// ./src/presentation/component/customer/top_page/customer_top_page.tsx